import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeadersModule } from '@shared/core/components/headers';
import { ButtonsModule } from '@shared/core/components/buttons';
import { TextModule } from '@shared/core/components/text';
import { FormForAddressModule } from '@shared/core/modules/forms/formTypes/forAddress';

import { ModalsTypesModule } from '../../modalsTypes';

import { ModalForDeliveryAddressComponent } from './modal-for-delivery-address.shared.component';

@NgModule({
    declarations: [
        ModalForDeliveryAddressComponent,
    ],
    imports: [
        CommonModule,
        ModalsTypesModule,
        HeadersModule,
        ButtonsModule,
        TextModule,
        FormForAddressModule,
    ],
    exports: [
        ModalForDeliveryAddressComponent,
    ],
})
export class ModalForDeliveryAddressModule { }
